var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinusBlack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#343A40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.97 6.559c.418 0 .773-.349.773-.78 0-.424-.355-.779-.772-.779H1.072C.67 5 .3 5.355.3 5.78c0 .43.37.779.772.779h9.899z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinusBlack2);
export default __webpack_public_path__ + "static/media/ic_minus_black_2.c188698bf0d962cf25b58452aff2f805.svg";
export { ForwardRef as ReactComponent };